import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.scss';
import './assets/fonts/Publica-Sans-Bold.ttf';
import './assets/fonts/Publica-Sans-Medium.ttf';
import './assets/fonts/Publica-Sans-Light.ttf';
import './assets/fonts/PublicaSans.ttf';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
